import { render, staticRenderFns } from "./apds_iap.vue?vue&type=template&id=812c7bce&scoped=true"
import script from "./apds_iap.vue?vue&type=script&lang=js"
export * from "./apds_iap.vue?vue&type=script&lang=js"
import style0 from "./apds_iap.vue?vue&type=style&index=0&id=812c7bce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "812c7bce",
  null
  
)

export default component.exports